<div class="title" [innerHTML]="'twoFactorDialog_Data27' | i18n"></div>
<div class="subtitle limit-reached" [innerHTML]="'twoFactorDialog_Data28' | i18n"></div>
<button class="btn" (click)="closeDialog()" [innerHTML]="'twoFactorDialog_Data29' | i18n"></button>
